<template>
  <a class="menu-preview" :href="menu.url">
    <div class="columns is-multiline is-centered is-mobile" :style="{'background-color': menu.image_color}">
      <div class="column is-half" v-for="(recipe, index) in menu.recipes.slice(0, 2)" :key="index">
        <recipe-preview-simple :recipe="recipe" no-link/>
      </div>
    </div>
    <h2 class="title has-text-centered">{{menu.name}}</h2>
    <div class="overlay">
      <div class="top-left">
        {{menu.recipes.length}} {{$t('recipes')}}
      </div>
    </div>
  </a>
</template>

<script>
import RecipePreviewSimple from '../recipe/PreviewSimple.vue'

export default {
  props: {
    menu: {type: Object, default: () => ({})}
  },

  components: {
    RecipePreviewSimple
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/menu/Preview.vue